<template>
    <div>
        <div class="d-flex align-items-center justify-content-between gap-2">
            <label class="form-label">{{ title }}</label>
            <slot name="label-aside"></slot>
        </div>
        <input
            v-model="internalValue"
            type="text"
            :class="errors && errors.length > 0 ? 'form-control is-invalid' : 'form-control'"
        >
        <div v-for="errorMess in errors" class="invalid-feedback">{{ errorMess }}</div>
    </div>
</template>

<script>
export default {
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        errors: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            internalValue: this.modelValue,
        };
    },
    watch: {
        modelValue(val) {
            this.internalValue = val;
        },
        internalValue(val) {
            if (val) {
                val = val.toString().replace(',', '.');
            }
            if (val) {
                val = val.replace(/[^0-9.]/g, '');
                let matches = val.match(/\./g);
                if (matches && matches.length > 1) {
                    val = val.substring(0, val.indexOf('.', val.indexOf('.') + 1));
                }
            }
            this.internalValue = val;
            this.$emit('update:modelValue', val);
            this.$emit('change', val);
        },
    },
};
</script>
